export default "__VITE_ASSET__DESOIoX1__"